import { datadogRum } from '@datadog/browser-rum'

import { APP_VERSION, SENTRY_ENVIRONMENT } from './constants'

// Only initialize RUM in production and over HTTPS (required for partitioned cookies)
if (process.env.NODE_ENV === 'production' && location.protocol === 'https:') {
  datadogRum.init({
    applicationId: '2f0e5e76-569d-4c3a-947b-3e5b083476e2',
    clientToken: 'pub8310a88dd926b95607164d3eaac7678e',
    site: 'datadoghq.com',
    service: 'dolphin-booking',
    env: SENTRY_ENVIRONMENT,
    version: APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 1,
    defaultPrivacyLevel: 'mask-user-input',
    usePartitionedCrossSiteSessionCookie: true,
    sessionPersistence: 'cookie',
    allowFallbackToLocalStorage: true,
    trackViewsManually: true,
  })

  setTimeout(() => {
    const hasDatadogCookie =
      document.cookie.includes('_dd_s') || document.cookie.includes('_dd_r')
    if (!hasDatadogCookie && typeof datadogRum.addAction === 'function') {
      datadogRum.addAction('rumSessionCookieMissing', {
        detail:
          'Session cookie not detected. Iframe sandbox restrictions may be blocking cookie access.',
      })
    }
  }, 1000)
}
